import { useAppState } from '@/contexts/AppStateContext';
import './Header.css';
import { useTheme } from '@/contexts/ThemeContext';

export const Header = () => {
  const { theme } = useTheme();
  const { appState } = useAppState();
  const headerSrc = theme.logoUrl ? `logos/${theme.logoUrl}`  : "/images/H010.png";
  const innerStatus = ['playing','validating','showtemplate','done'].includes(appState) && headerSrc ? 'show' : '';

  return (
    <div
      className={`h-[25vh] min-h-[25vh] header ${innerStatus}`}
      data-testid="header-container">
      {innerStatus === 'show' && <img src={headerSrc} alt={'Logo'} className={`w-[335px] md:w-[420px] h-auto`} />}
    </div>
  );
}